import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[rowActions]' })
export class RowActionsDirective {
    constructor(public tpl: TemplateRef<any>) {}
}
